import styled, { css } from "styled-components"
import Breakpoints from "./breakpoints"
import { IStyleVariant } from "../../design-system/atoms/variant-container"

interface IFadedTitleWrapper {
  fadeSettings: IStyleVariant
  imageType: string
}

interface IFadedTitleSectionHeading {
  textAlign?: string
  textStyles?: IStyleVariant
}

const none = css`
  display: none;
`

const left = css`
  display: block;
  position: absolute;
  left: -64px;
  top: -48px;
  transform: none;
`

const center = css`
  display: block;
  position: absolute;
  top: -48px;
  left: 50%;
  transform: translateX(-50%);
`

const imageSettings = {
  none: none,
  left: left,
  center: center,
}

export const Wrapper = styled.div<IFadedTitleWrapper>`
  position: relative;
  display: inline-block;
  & > ${(props) => props.imageType} {
    user-select: none;
    pointer-events: none;
    ${(props) =>
      props.fadeSettings["sm"]
        ? imageSettings[props.fadeSettings["sm"]]
        : imageSettings.none}
  }

  @media (min-width: ${Breakpoints.md}) {
    & > ${(props) => props.imageType} {
      ${(props) =>
        props.fadeSettings["md"]
          ? imageSettings[props.fadeSettings["md"]]
          : imageSettings.none}
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    & > ${(props) => props.imageType} {
      ${(props) =>
        props.fadeSettings["lg"]
          ? imageSettings[props.fadeSettings["lg"]]
          : imageSettings.none}
    }
  }
`

export const SectionHeading = styled.h3<IFadedTitleSectionHeading>`
  color: var(--slate);
  width: 100%;

  text-align: ${(props) => props.textAlign || "left"};

  ${(props) => props.textStyles?.sm}

  @media(min-width: ${Breakpoints.md}) {
    ${(props) => props.textStyles?.md}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${(props) => props.textStyles?.lg}
  }
`
